import { MatterFileType } from './matter';

export interface MatterChecklistVM {
	id: string;
	title: string;
	stages: ChecklistStageVM[];
	congratsMessage?: string;
}
export interface BusinessChecklistVM extends MatterChecklistVM {
	draft: boolean;
	fileType: MatterFileType;
	lastEdited: string;
	created: string;
	locked: boolean;
	default: boolean;
}

export type ChecklistItemType = 'task' | 'stage' | 'template';

export interface ChecklistItem {
	id: string;
	businessId: string;
	type: ChecklistItemType;
	title: string;
	headNode: boolean;
	nextNodeId: string;
	matterId?: string;
	parentId?: string;
	complete?: boolean;
	congratsMessage?: string;
	created?: string;
	lastEdited?: string;
	fileType?: MatterFileType;
	locked?: boolean;
	draft?: boolean;
	default?: boolean;
	fieldPath?: string;
	opened?: boolean;
}

export interface ChecklistStageVM {
	id: string;
	title: string;
	tasks: ChecklistTaskVM[];
}

export interface ChecklistTaskVM {
	id: string;
	title: string;
	complete: boolean;
	fieldPath?: string;
}

export const SaleChecklistItems: ChecklistItem[] = [
	{
		id: 'sale-preclosing',
		businessId: '1',
		parentId: 'sale',
		title: 'Pre-Closing',
		type: 'stage',
		headNode: true,
		nextNodeId: 'sale-closing',
	},
	{
		id: 'sale-preclosing-1',
		businessId: '1',
		parentId: 'sale-preclosing',
		title: 'Client information',
		type: 'task',
		complete: false,
		headNode: true,
		nextNodeId: 'sale-preclosing-2',
	},
	{
		id: 'sale-preclosing-2',
		businessId: '1',
		parentId: 'sale-preclosing',
		title: 'Title search',
		type: 'task',
		complete: false,
		nextNodeId: 'sale-preclosing-3',
		headNode: false,
		fieldPath: 'matter.requisitionStatus.uploaded',
	},
	{
		id: 'sale-preclosing-3',
		businessId: '1',
		parentId: 'sale-preclosing',
		title: 'Encumbrances',
		type: 'task',
		complete: false,
		nextNodeId: 'sale-preclosing-4',
		headNode: false,
	},
	{
		id: 'sale-preclosing-4',
		businessId: '1',
		parentId: 'sale-preclosing',
		title: 'Response to requisitions',
		type: 'task',
		complete: false,
		nextNodeId: 'sale-preclosing-5',
		headNode: false,
	},
	{
		id: 'sale-preclosing-5',
		businessId: '1',
		parentId: 'sale-preclosing',
		title: 'Adjustments',
		type: 'task',
		complete: false,
		nextNodeId: 'sale-preclosing-6',
		headNode: false,
	},
	{
		id: 'sale-preclosing-6',
		businessId: '1',
		parentId: 'sale-preclosing',
		title: 'Documents',
		type: 'task',
		complete: false,
		nextNodeId: 'sale-preclosing-7',
		headNode: false,
	},
	{
		id: 'sale-preclosing-7',
		businessId: '1',
		parentId: 'sale-preclosing',
		title: 'Appointment',
		type: 'task',
		complete: false,
		nextNodeId: '',
		headNode: false,
	},
	{
		id: 'sale-closing',
		businessId: '1',
		parentId: 'sale',
		title: 'Closing',
		type: 'stage',
		nextNodeId: 'sale-postclosing',
		headNode: false,
	},
	{
		id: 'sale-closing-9',
		businessId: '1',
		parentId: 'sale-closing',
		title: 'Obtain funds',
		type: 'task',
		complete: false,
		headNode: true,
		nextNodeId: 'sale-closing-10',
	},
	{
		id: 'sale-closing-10',
		businessId: '1',
		parentId: 'sale-closing',
		title: 'E-registration',
		type: 'task',
		complete: false,
		nextNodeId: 'sale-closing-11',
		headNode: false,
	},
	{
		id: 'sale-closing-11',
		businessId: '1',
		parentId: 'sale-closing',
		title: 'Disburse funds',
		type: 'task',
		complete: false,
		nextNodeId: '',
		headNode: false,
	},
	{
		id: 'sale-postclosing',
		businessId: '1',
		parentId: 'sale',
		title: 'Post-Closing',
		type: 'stage',
		nextNodeId: '',
		headNode: false,
	},
	//sale-postclosing-12 is used to sync item for the report export
	{
		id: 'sale-postclosing-12',
		businessId: '1',
		parentId: 'sale-postclosing',
		title: 'Final report',
		type: 'task',
		complete: false,
		headNode: true,
		nextNodeId: 'sale-postclosing-13',
	},
	{
		id: 'sale-postclosing-13',
		businessId: '1',
		parentId: 'sale-postclosing',
		title: 'Register discharge',
		type: 'task',
		complete: false,
		nextNodeId: 'sale-postclosing-14',
		headNode: false,
	},
	{
		id: 'sale-postclosing-14',
		businessId: '1',
		parentId: 'sale-postclosing',
		title: 'Undertakings given',
		type: 'task',
		complete: false,
		nextNodeId: 'sale-postclosing-15',
		headNode: false,
	},
	{
		id: 'sale-postclosing-15',
		businessId: '1',
		parentId: 'sale-postclosing',
		title: 'Release holdbacks',
		type: 'task',
		complete: false,
		nextNodeId: '23',
		headNode: false,
	},
];

export const PurchaseChecklistItems: ChecklistItem[] = [
	{
		id: 'purchase-preclosing',
		businessId: '1',
		parentId: 'purchase',
		title: 'Pre-Closing',
		type: 'stage',
		headNode: true,
		nextNodeId: 'purchase-closing',
	},
	{
		id: 'purchase-preclosing-1',
		businessId: '1',
		parentId: 'purchase-preclosing',
		title: 'Client information',
		type: 'task',
		complete: false,
		headNode: true,
		nextNodeId: 'purchase-preclosing-2',
	},
	{
		id: 'purchase-preclosing-2',
		businessId: '1',
		parentId: 'purchase-preclosing',
		title: 'Title search',
		type: 'task',
		complete: false,
		nextNodeId: 'purchase-preclosing-3',
		headNode: false,
	},
	{
		id: 'purchase-preclosing-3',
		businessId: '1',
		parentId: 'purchase-preclosing',
		title: 'Title insurance',
		type: 'task',
		complete: false,
		nextNodeId: 'purchase-preclosing-4',
		headNode: false,
	},
	{
		id: 'purchase-preclosing-4',
		businessId: '1',
		parentId: 'purchase-preclosing',
		title: 'Requisitions',
		type: 'task',
		complete: false,
		nextNodeId: 'purchase-preclosing-5',
		headNode: false,
		fieldPath: 'matter.requisitionStatus.uploaded',
	},
	{
		id: 'purchase-preclosing-5',
		businessId: '1',
		parentId: 'purchase-preclosing',
		title: 'New mortgages',
		type: 'task',
		complete: false,
		nextNodeId: 'purchase-preclosing-6',
		headNode: false,
	},
	{
		id: 'purchase-preclosing-6',
		businessId: '1',
		parentId: 'purchase-preclosing',
		title: 'Fire insurance',
		type: 'task',
		complete: false,
		nextNodeId: 'purchase-preclosing-7',
		headNode: false,
	},
	{
		id: 'purchase-preclosing-7',
		businessId: '1',
		parentId: 'purchase-preclosing',
		title: 'Adjustments',
		type: 'task',
		complete: false,
		nextNodeId: 'purchase-preclosing-8',
		headNode: false,
	},
	{
		id: 'purchase-preclosing-8',
		businessId: '1',
		parentId: 'purchase-preclosing',
		title: 'Appointment',
		type: 'task',
		complete: false,
		nextNodeId: 'purchase-preclosing-9',
		headNode: false,
	},
	{
		id: 'purchase-closing',
		businessId: '1',
		parentId: 'purchase',
		title: 'Closing',
		type: 'stage',
		nextNodeId: 'purchase-postclosing',
		headNode: false,
	},
	{
		id: 'purchase-closing-10',
		businessId: '1',
		parentId: 'purchase-closing',
		title: 'Obtain funds',
		type: 'task',
		complete: false,
		headNode: true,
		nextNodeId: 'purchase-closing-11',
	},
	{
		id: 'purchase-closing-11',
		businessId: '1',
		parentId: 'purchase-closing',
		title: 'E-registration',
		type: 'task',
		complete: false,
		nextNodeId: 'purchase-closing-12',
		headNode: false,
	},
	{
		id: 'purchase-closing-12',
		businessId: '1',
		parentId: 'purchase-closing',
		title: 'Disburse funds',
		type: 'task',
		complete: false,
		nextNodeId: 'purchase-closing-13',
		headNode: false,
	},
	{
		id: 'purchase-closing-13',
		businessId: '1',
		parentId: 'purchase-closing',
		title: 'Release keys',
		type: 'task',
		complete: false,
		nextNodeId: '',
		headNode: false,
	},
	{
		id: 'purchase-postclosing',
		businessId: '1',
		parentId: 'purchase',
		title: 'Post-Closing',
		type: 'stage',
		nextNodeId: '',
		headNode: false,
	},
	//purchase-postclosing-14 & 15 are used to sync these two items for the report export
	{
		id: 'purchase-postclosing-14',
		businessId: '1',
		parentId: 'purchase-postclosing',
		title: 'Report to client',
		type: 'task',
		complete: false,
		headNode: true,
		nextNodeId: 'purchase-postclosing-15',
	},
	{
		id: 'purchase-postclosing-15',
		businessId: '1',
		parentId: 'purchase-postclosing',
		title: 'Report to lender',
		type: 'task',
		complete: false,
		nextNodeId: '',
		headNode: false,
	},
];

export const RefinanceChecklistItems: ChecklistItem[] = [
	{
		id: 'refinance-preclosing',
		businessId: '1',
		parentId: 'refinance',
		title: 'Pre-Closing',
		type: 'stage',
		headNode: true,
		nextNodeId: 'refinance-closing',
	},
	{
		id: 'refinance-preclosing-1',
		businessId: '1',
		parentId: 'refinance-preclosing',
		title: 'Mortgage intake',
		type: 'task',
		complete: false,
		headNode: true,
		nextNodeId: 'refinance-preclosing-2',
	},
	{
		id: 'refinance-preclosing-2',
		businessId: '1',
		parentId: 'refinance-preclosing',
		title: 'Client information',
		type: 'task',
		complete: false,
		nextNodeId: 'refinance-preclosing-3',
		headNode: false,
	},
	{
		id: 'refinance-preclosing-3',
		businessId: '1',
		parentId: 'refinance-preclosing',
		title: 'Title search',
		type: 'task',
		complete: false,
		nextNodeId: 'refinance-preclosing-4',
		headNode: false,
	},
	{
		id: 'refinance-preclosing-4',
		businessId: '1',
		parentId: 'refinance-preclosing',
		title: 'Title insurance',
		type: 'task',
		complete: false,
		nextNodeId: 'refinance-preclosing-5',
		headNode: false,
	},
	{
		id: 'refinance-preclosing-5',
		businessId: '1',
		parentId: 'refinance-preclosing',
		title: 'Encumbrances',
		type: 'task',
		complete: false,
		nextNodeId: 'refinance-preclosing-6',
		headNode: false,
	},
	{
		id: 'refinance-preclosing-6',
		businessId: '1',
		parentId: 'refinance-preclosing',
		title: 'Fire insurance',
		type: 'task',
		complete: false,
		nextNodeId: 'refinance-preclosing-7',
		headNode: false,
	},
	{
		id: 'refinance-preclosing-7',
		businessId: '1',
		parentId: 'refinance-preclosing',
		title: 'Appointment',
		type: 'task',
		complete: false,
		nextNodeId: '',
		headNode: false,
	},
	{
		id: 'refinance-closing',
		businessId: '1',
		parentId: 'refinance',
		title: 'Closing',
		type: 'stage',
		nextNodeId: 'refinance-postclosing',
		headNode: false,
	},
	{
		id: 'refinance-closing-8',
		businessId: '1',
		parentId: 'refinance-closing',
		title: 'Obtain funds',
		type: 'task',
		complete: false,
		headNode: true,
		nextNodeId: 'refinance-closing-9',
	},
	{
		id: 'refinance-closing-9',
		businessId: '1',
		parentId: 'refinance-closing',
		title: 'E-registration',
		type: 'task',
		complete: false,
		nextNodeId: 'refinance-closing-10',
		headNode: false,
	},
	{
		id: 'refinance-closing-10',
		businessId: '1',
		parentId: 'refinance-closing',
		title: 'Disburse funds',
		type: 'task',
		complete: false,
		nextNodeId: '',
		headNode: false,
	},
	{
		id: 'refinance-postclosing',
		businessId: '1',
		parentId: 'refinance',
		title: 'Post-Closing',
		type: 'stage',
		nextNodeId: '',
		headNode: false,
	},
	{
		id: 'refinance-postclosing-11',
		businessId: '1',
		parentId: 'refinance-postclosing',
		title: 'Final report',
		type: 'task',
		complete: false,
		headNode: true,
		nextNodeId: 'refinance-postclosing-12',
	},
	{
		id: 'refinance-postclosing-12',
		businessId: '1',
		parentId: 'refinance-postclosing',
		title: 'Receive discharge',
		type: 'task',
		complete: false,
		nextNodeId: '',
		headNode: false,
	},
];

export const SampleChecklistTemplates: ChecklistItem[] = [
	{
		id: 'sale',
		businessId: '1',
		type: 'template',
		title: 'Sale file',
		fileType: MatterFileType.SALE,
		created: '2023-10-16T20:50:56.122Z',
		lastEdited: '2023-10-16T20:50:56.122Z',
		locked: true,
		draft: false,
		nextNodeId: '',
		headNode: true,
	},
	{
		id: 'purchase',
		businessId: '1',
		type: 'template',
		title: 'Purchase file',
		fileType: MatterFileType.PURCHASE,
		created: '2023-10-16T20:50:56.122Z',
		lastEdited: '2023-10-16T20:50:56.122Z',
		locked: true,
		draft: false,
		nextNodeId: '',
		headNode: true,
	},
	{
		id: 'refinance',
		businessId: '1',
		type: 'template',
		title: 'Refinance file',
		fileType: MatterFileType.REFINANCE,
		created: '2023-10-16T20:50:56.122Z',
		lastEdited: '2023-10-16T20:50:56.122Z',
		locked: true,
		draft: false,
		nextNodeId: '',
		headNode: true,
	},
];
